import React, {useState} from "react";
import {useForm} from "react-hook-form";
import SellerApplicationFields from "./SellerApplicationFields";

export default function () {
  const {register, handleSubmit, watch, reset} = useForm();
  const [errors, setErrors] = useState({});

  const sellerApplicationFields = <SellerApplicationFields {...{register, watch, errors}} />;

  return {
    setErrors,
    sellerApplicationFields,
    handleSubmit,
    reset,
  }
}